"use client";
import React, { useCallback } from "react";
import Icon from "../icons/Icons";
import { useDispatch } from "react-redux";
import { openKeywordModal, setKeywordModalKey } from "@/redux/features/KeywordModal/keywordSlice";

type Props = {
  keywords: string;
  className?: string;
};

export default function InformationButton({ keywords, className }: Props) {
  const dispatch = useDispatch();

  const handleButton = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      e.stopPropagation(); // 👈 stops parent onClick

      dispatch(openKeywordModal());
      dispatch(setKeywordModalKey(keywords));
    },
    [dispatch, keywords],
  );

  return (
    <button type="button" onClick={handleButton} className="border-none bg-none" aria-label="Show More Information About This Item" title={`Click For More Information About This`}>
      <Icon.infoIcon className={`w-4.5 h-4.5 sm:w-6 sm:h-6 rotate-180 shrink-0 transition text-primaryBlack hover:text-primaryBlue ${className}`} />
    </button>
  );
}
